import { Password, StarsButton, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import { addDays, differenceInDays } from 'date-fns';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { styles as sharedStyles, useSelfExclusionData } from '@swf/account';

import styles from '../../../shared.scss';
import AccountDate from '../../AccountDate/AccountDate';

import {
  TXTCLI_Confirm,
  TXTCLI_Password,
  TXTWCL_Based_on_the_number_of_days_pa_ELL,
  TXTWCL_Enter_your_password_to_confirm,
  TXTWCL_FirstX_you_must_complete_the_m_ELL,
  TXTWCL_Go_back,
  TXTWCL_Please_enter_the_correct_passw_ELL,
  TXTWCL_Please_enter_your_PasswordX,
  TXTWCL_Please_enter_your_password_to__ELL,
  TXTWCL_You_are_going_to_end_your_XbXt_ELL
} from './ExclusionRevocationFormConfirm.messages.json';

interface Props {
  invalidPassword: boolean;
  handleCancel: () => void;
  pristine: boolean;
}

const ExclusionRevocationFormConfirm: React.FC<Props> = ({
  invalidPassword,
  handleCancel,
  pristine
}) => {
  const { formatMessage } = useIntl();
  const { selfExclusionData } = useSelfExclusionData();

  const endDate = useMemo(() => {
    const diff = selfExclusionData
      ? differenceInDays(new Date(), new Date(selfExclusionData?.timeFrom))
      : 0;
    const amountOfDays = diff > 60 ? 30 : 90 - diff;
    return addDays(new Date(), amountOfDays);
  }, [selfExclusionData]);

  return (
    <>
      <Translation tagName="p" {...TXTWCL_You_are_going_to_end_your_XbXt_ELL} />
      <Translation tagName="p" {...TXTWCL_FirstX_you_must_complete_the_m_ELL} />
      <Translation
        tagName="p"
        {...TXTWCL_Based_on_the_number_of_days_pa_ELL}
        values={{ 0: <AccountDate date={endDate} /> }}
      />
      <Translation {...TXTWCL_Please_enter_your_password_to__ELL} />
      <Password
        id="password"
        error={invalidPassword}
        label={TXTCLI_Password}
        className={sharedStyles.restrictedWidth}
        placeholder={formatMessage(TXTWCL_Enter_your_password_to_confirm)}
        validators={[required(TXTWCL_Please_enter_your_PasswordX)]}
      />
      {invalidPassword && (
        <p className={sharedStyles.red}>
          <Translation {...TXTWCL_Please_enter_the_correct_passw_ELL} />
        </p>
      )}
      <div className={styles.revocationButtons}>
        <StarsButton
          type="submit"
          className={styles.button}
          disabled={pristine}
          translation={TXTCLI_Confirm}
        />
        <StarsButton
          variant="secondary"
          onClick={handleCancel}
          className={styles.button}
          translation={TXTWCL_Go_back}
        />
      </div>
    </>
  );
};

export default ExclusionRevocationFormConfirm;
